import React from 'react'
import AddUserForm from 'shared/components/Forms/AddUserForm'
import SignupContainer from 'views/SignupContainer'

const AddUser = () => {
  return (
    <SignupContainer>
      <AddUserForm/>
    </SignupContainer>
  )
}

export default AddUser